import styled from '@emotion/styled'

import theme from 'styles/theme'

export const CategoriesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 10px;
  justify-content: space-between;
  margin-top: 28px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    margin-top: 80px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 215px);
    justify-content: center;
  }

  p {
    margin-top: 0;
    hyphens: auto;

    @media (min-width: ${theme.token('breakpoints.lg')}) {
      hyphens: none;
    }
  }

  img {
    width: auto;

    @media (min-width: ${theme.token('breakpoints.md')}) {
      width: 120px;
    }

    @media (min-width: ${theme.token('breakpoints.lg')}) {
      min-width: 120px;
      max-width: 100%;
      width: auto;
      max-height: 140px;
      height: auto;
      min-height: 120px;
    }
  }
`
